module.exports = __webpack_public_path__ + "img/CL.e9d30f1f.jpg";